import React from "react";
import { Container, Header, Image, Divider } from "semantic-ui-react";
export const curate_app = () => {
  return (
    <Container>
      <Divider hidden />
      <Header as="h1">
        <Header.Content>Curate app</Header.Content>
        <Header.Subheader>
          <p>
            Curate is Zaya's internal tool to curate content for both classcloud
            and English Duniya. Had fun redesigning and developing it. One of
            the screen shot of how preview of questions look like is given
            below.
          </p>
          <p>Credit : Re-esigned and co-developed</p>
        </Header.Subheader>
      </Header>
      <Divider />
      <Image
        src="https://firebasestorage.googleapis.com/v0/b/colorpallete-8e80c.appspot.com/o/curateapp%2F1.png?alt=media&token=d5fc8680-d5a7-4914-8e73-15b65d51f4fd"
        rounded
      />
    </Container>
  );
};



// WEBPACK FOOTER //
// ./src/Projects/curate_app.js